export enum AssistantType {
  Citizen = 0,
  Fasit = 1,
}
